var render = function render(){var _vm=this,_c=_vm._self._c;return _c('empty-state',{attrs:{"title":_vm.title,"description":_vm.description,"image":"email-broadcasts-color"}},[_c('ds-outline-button',{attrs:{"data-qa":"create-broadcast-button"},on:{"click":function($event){return _vm.$emit('new-email')}}},[_vm._v(" "+_vm._s(_vm.action)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }